import { render, staticRenderFns } from "./sendNotification.vue?vue&type=template&id=30b13975&scoped=true"
import script from "./sendNotification.vue?vue&type=script&lang=js"
export * from "./sendNotification.vue?vue&type=script&lang=js"
import style0 from "./sendNotification.vue?vue&type=style&index=0&id=30b13975&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b13975",
  null
  
)

export default component.exports